import { CSSProperties } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IBadgeInfiniteScroll } from './types';
import { styles } from './styles';
import { CircularProgress, Grid } from '@mui/material';

export const BadgeInfiniteScroll = ({
  hasMore,
  dataLength,
  children,
  getMore,
}: IBadgeInfiniteScroll) => {
  return (
    <InfiniteScroll
      next={getMore}
      hasMore={hasMore}
      dataLength={dataLength}
      height={400}
      style={styles.infiniteScroll as CSSProperties}
      loader={
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            width: '100%',
          }}
        >
          <CircularProgress />
        </Grid>
      }
    >
      {children}
    </InfiniteScroll>
  );
};
